import cn from "classnames";
import { Link } from "react-router-dom";
import CheckboxForm from "../CheckboxForm";
import TextInput from "../Form/TextInput";
import FileInput from "../Form/FileInput";

const PropertyAdminSection = ({
  values,
  errors,
  touched,
  handleChange,
  styles,
  difference,
  router,
  isAgent,
  currentProperty,
}) => {
  if (isAgent) return null;

  return (
    <>
      {values["type"] === "top_search_cat_menu_apartments" && (
        <CheckboxForm
          key={`form-checkbox-topStudio`}
          handleChange={handleChange}
          label="Top garsonjera"
          checkboxClass={cn({
            [styles.checkboxEdited]:
              difference.includes("top_studio") &&
              router.includes("properties/edit"),
          })}
          formName="top_studio"
          values={values}
        />
      )}
      {values["type"] === "top_search_cat_menu_apartments" && (
        <CheckboxForm
          key={`form-checkbox-cheap`}
          handleChange={handleChange}
          label="Najjeftiniji stan"
          checkboxClass={cn({
            [styles.checkboxEdited]:
              difference.includes("cheap") &&
              router.includes("properties/edit"),
          })}
          formName="cheap"
          values={values}
        />
      )}
      <CheckboxForm
        key={`form-checkbox-urgent`}
        handleChange={handleChange}
        label="Hitna prodaja"
        checkboxClass={cn({
          [styles.checkboxEdited]:
            difference.includes("urgent") && router.includes("properties/edit"),
        })}
        formName="urgent"
        values={values}
      />
      <CheckboxForm
        key={`form-checkbox-top`}
        handleChange={handleChange}
        label="Top pozicija u pretrazi"
        checkboxClass={cn({
          [styles.checkboxEdited]:
            difference.includes("top") && router.includes("properties/edit"),
        })}
        formName="top"
        values={values}
      />
      <CheckboxForm
        key={`form-checkbox-new`}
        handleChange={handleChange}
        label="Novogradnja"
        checkboxClass={cn({
          [styles.checkboxEdited]:
            difference.includes("new") && router.includes("properties/edit"),
        })}
        formName="new"
        values={values}
      />
      <CheckboxForm
        key={`form-checkbox-deleted`}
        handleChange={handleChange}
        label="Obrisana nekretnina"
        checkboxClass={cn({
          [styles.checkboxEdited]:
            difference.includes("deleted") &&
            router.includes("properties/edit"),
        })}
        formName="deleted"
        values={values}
      />
      <CheckboxForm
        key={`form-checkbox-sold`}
        handleChange={handleChange}
        label="Prodata nekretnina"
        checkboxClass={cn({
          [styles.checkboxEdited]:
            difference.includes("sold") && router.includes("properties/edit"),
        })}
        formName="sold"
        values={values}
      />
      <CheckboxForm
        key={`form-checkbox-exclusive`}
        handleChange={handleChange}
        label="Ekskluzivno"
        checkboxClass={cn({
          [styles.checkboxEdited]:
            difference.includes("exclusive") &&
            router.includes("properties/edit"),
        })}
        formName="exclusive"
        values={values}
      />
      <CheckboxForm
        key={`form-checkbox-lux`}
        handleChange={handleChange}
        label="Lux nekretnine"
        checkboxClass={cn({
          [styles.checkboxEdited]:
            difference.includes("lux") && router.includes("properties/edit"),
        })}
        formName="lux"
        values={values}
      />
      <CheckboxForm
        key={`form-checkbox-picturesView`}
        handleChange={handleChange}
        label="Slike nekretnine"
        checkboxClass={cn({
          [styles.checkboxEdited]:
            difference.includes("pictures_view") &&
            router.includes("properties/edit"),
        })}
        formName="pictures_view"
        values={values}
      />
      <Link
        target="_blank"
        to={`/properties/edit/images/${currentProperty._id}`}
      >
        {" "}
        Dodaj Slike
      </Link>
      <CheckboxForm
        key={`form-checkbox-contract`}
        handleChange={handleChange}
        label="Ugovor"
        checkboxClass={cn({
          [styles.checkboxEdited]:
            difference.includes("contract") &&
            router.includes("properties/edit"),
        })}
        formName="contract"
        values={values}
      />
      <TextInput
        key={`form-input-contractEnds`}
        values={values}
        formName="contract_ends"
        className={cn({
          [styles.editedObject]:
            difference.includes("contract_ends") &&
            router.includes("properties/edit"),
        })}
        type="date"
        handleChange={handleChange}
        placeholder="Ugovor ističe"
        label="Ugovor ističe:"
        errors={errors}
        touched={touched}
      />
      <FileInput
        key={`form-file-input-images`}
        values={values}
        handleChange={handleChange}
        label="Slike nekretnine"
        formName="images"
        accept="image/png, image/gif, image/jpeg"
        errors={errors}
        touched={touched}
        multiple
      />
    </>
  );
};

export default PropertyAdminSection;
